/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import { message } from 'antd'
import WrappedDrawer from '@/components/WrappedDrawer'
import { putSystemPermissionRoles } from '@/service/systemControl'
import PermissionAssignRolesForm from './PermissionAssignRolesForm'

class PermissionAssignRolesDrawer extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    record: PropTypes.object.isRequired,
    baseProps: PropTypes.object,
    onSuccess: PropTypes.func,
    title: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }

  static defaultProps = {
    title: '为权限分配角色',
    baseProps: {}
  }

  state = {
    drawerWidth:
      typeof window !== 'undefined' && window.matchMedia('(max-width: 767px)').matches
        ? '100%'
        : 520
  }

  mediaQuery = null

  componentDidMount() {
    this.mediaQuery = window.matchMedia('(max-width: 767px)')
    this.applyDrawerWidth()
    this.mediaQuery.addEventListener('change', this.applyDrawerWidth)
  }

  componentWillUnmount() {
    if (this.mediaQuery) {
      this.mediaQuery.removeEventListener('change', this.applyDrawerWidth)
    }
  }

  applyDrawerWidth = () => {
    if (!this.mediaQuery) return
    this.setState({
      drawerWidth: this.mediaQuery.matches ? '100%' : 520
    })
  }

  handleOk = async (form) => {
    const { onSuccess, record } = this.props
    const permissionId = record?.id
    if (permissionId == null) {
      message.error('缺少权限 id')
      throw new Error('缺少权限 id')
    }
    const fields = await form.current.validateFields()
    const raw = fields.roleIds
    const roleIds = Array.isArray(raw)
      ? raw.map((k) => {
        const n = Number(k)
        return Number.isNaN(n) ? k : n
      })
      : []
    const roleIdsStr = roleIds.map((id) => String(id)).join(',')
    const body = { roleIds: roleIdsStr }
    try {
      await putSystemPermissionRoles(permissionId, body)
      message.success('角色已更新')
      if (typeof onSuccess === 'function') {
        await Promise.resolve(onSuccess())
      }
    } catch (e) {
      message.error(e?.message || e?.msg || '保存失败')
      throw e
    }
  }

  render() {
    const { children, baseProps, title, width: widthProp, record } = this.props
    const { drawerWidth } = this.state
    const width = widthProp !== undefined ? widthProp : drawerWidth

    return (
      <WrappedDrawer
        children={children}
        title={title}
        width={width}
        baseComponent={<PermissionAssignRolesForm />}
        baseProps={{
          ...baseProps,
          record
        }}
        onOk={this.handleOk}
        bodyStyle={{
          padding: '12px 16px 72px'
        }}
      />
    )
  }
}

export default PermissionAssignRolesDrawer
